/*!

=========================================================
* Black Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// react plugin used to create charts

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { 
  fetchGetUserList, 
  fetchRemoveUser, 
  fetchGetModelsByUserId, 
  fetchRemoveUserInitialize
} from "../actions/user_actions";
import { 
  fetchDeleteModel, 
  fetchVersionOperation, 
  fetchDeleteModelInitialize, 
  fetchDeleteVersionInitialize 
} from "../actions/model_actions";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  Row,
  Col
} from "reactstrap";

import ReactTable from "react-table";
import ReactBSAlert from "react-bootstrap-sweetalert";
import NotificationAlert from "react-notification-alert";
// modals
import UserRegisterModal from "../views/modals/user_register_modal";
import WatchUserModal from "../views/modals/watch_user_modal";
import UserEditModal from "../views/modals/user_edit_modal";
import ModelRegisterModal from "../views/modals/model_register_modal";
import ModelEditModal from "../views/modals/model_edit_modal";
import VersionRegisterModal from "../views/modals/version_add_modal";

class Users extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bigChartData: "data1",
      addUser: false,
      addModel: false,
      userId: "",
      userId_isValidated: null,
      model_id: "",
      userIdState: "",
      model_nameState: "",
      userList: [],
      userView: {},
      modalWatchUserData: false,
      modalEditUserData: false,
      is_admin: false,
      showModelEdit: {},
      showModelAddVersion: {},
      showModelDeleteVersion: {},
      versionToDelete: {},
      modelToDelete: [],
      editModel: false,
      showVersion: false,
      version_name: "",
      version_date: "",
      isModelSelectedChecked: false,
      alert: null
    };
  }

  componentDidMount() {
    const { fetchGetUserList, user } = this.props;
    if(user.user_list && user.user_list.length > 0) {
      let userListAux = user.user_list;
      this.setState({userList: userListAux.map(val => {
        let aux = val;
        aux.is_admin = aux.is_admin ? "Yes" : "No"
        return aux;
      })})
    }
    const idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    fetchGetUserList(idToken);
  }

  componentDidUpdate(prevProps, prevState) {
    const { user, auth, fetchGetUserList } = this.props;
    // console.log(user);
    if(user && prevProps.user && user.user_list && !prevProps.user.user_list || 
      (user.user_list && prevProps.user.user_list && user.user_list.length !== prevProps.user.user_list.length)) {
      let userListAux = user.user_list;
      this.setState({userList: userListAux.map(val => {
        let aux = val;
        aux.is_admin = aux.is_admin ? "Yes" : "No"
        return aux;
      })})
    }

    if(prevProps.auth.token === null && auth.token !== prevProps.auth.token) {
      console.log("Case 2: ", auth, prevProps.auth)
      let idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
      fetchGetUserList(idToken);
    }
    if(user && user.user_removed && user.user_removed !== prevProps.user.user_removed) {
      this.successDelete();
    }
    if(user && user.model_deleted && user.model_deleted !== prevProps.user.model_deleted) {
      this.successDeleteModel();
    }
    if(user && user.version_operation && user.version_operation.operation && user.version_operation.operation === "pop" && user.version_operation !== prevProps.user.version_operation) {
      this.successDeleteVersion();
    }
    if((user && prevProps.user && user.userId_validated && !prevProps.user.userId_validated) || 
        user && prevProps.user && user.userId_validated && prevProps.user.userId_validated && user.userId_validated !== prevProps.user.userId_validated) {
          if(user.userId_validated.result === true) {
            this.setState({userId_isValidated: true, userIdState: "has-success"});
          } else {
            this.setState({userId_isValidated: false, userIdState: "has-danger"});
          }
    }
    if(user && prevProps.user && user.fetchError && user.fetchError.detail && user.fetchError.detail !== "Error validating token" && user.fetchError !== prevProps.user.fetchError ) {
      var options = {};
      options = {
        place: "tc",
        message: (
          <div>
            <div>
              {user.fetchError.detail}.
            </div>
          </div>
        ),
        type: "warning",
        icon: "tim-icons icon-alert-circle-exc",
        autoDismiss: 7
      };
      this.refs.notificationAlert.notificationAlert(options);
    }
  }
  
  setBgChartData = name => {
    this.setState({
      bigChartData: name
    });
  };

  handleAddUserModal = () => {
    console.log("test");
    this.setState({
      addUser: !this.state.addUser
    });
  }

  handleAddModelModal = () => {
    this.setState({
      addModel: !this.state.addModel
    });
  };

  handleEditModelModal = () => {
    this.setState({
      editModel: !this.state.editModel,
      showModelEdit: {}
    });
  };

  toggleModalWatchUserData = (user) => {
    const { fetchGetModelsByUserId } = this.props;
    const { userView } =  this.state;
    let userId = user.currentTarget.id ? user.currentTarget.id : userView._id;
    const idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    let userModelsObj = {
      token: idToken,
      query_user: userId
    };
    // console.log(userModelsObj)
    fetchGetModelsByUserId(userModelsObj);
    let obj = this.state.userList.find(o => o._id === userId);
    // console.log(obj)
    this.setState({
      userView: obj,
      modalWatchUserData: !this.state.modalWatchUserData
    });
  };

  toggleModalEditUserData = (user) => {
    const { fetchGetModelsByUserId } = this.props;
    const { userView } =  this.state;
    let userId = user.currentTarget.id ? user.currentTarget.id : userView._id;
    // console.log(userId)
    const idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    let userModelsObj = {
      token: idToken,
      query_user: userId
    };
    // console.log(userModelsObj)
    fetchGetModelsByUserId(userModelsObj);
    let obj = this.state.userList.find(o => o._id === userId);
    // console.log(obj)
    this.setState({
      userView: obj,
      modalEditUserData: !this.state.modalEditUserData,
      showModelEdit: {},
      isModelSelectedChecked: false,
      showModelDeleteVersion: {},
      versionToDelete: [],
      isModelSelectedChecked: false,
      modelToDelete: []
    });
  };

  removeUser = (userId) => {
    const { fetchRemoveUser } = this.props;
    const idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    let removeObj = {
      token: idToken,
      user_id: userId
    };
    console.log(removeObj)
    fetchRemoveUser(removeObj);
  };
  
  toggleModalEditModel = (data) => {
    const { showModelEdit, modelToDelete } = this.state;
    // console.log("modelToDelete: ", modelToDelete)
    let modelArray = [];
    let filterModel = modelToDelete.filter(val => val.model_id === data.model_id);
    // console.log("filterModel: ", filterModel)
    if(filterModel.length === 0) {
      modelArray = [...modelToDelete, data]
    } else {
      modelArray = modelToDelete.filter(val => val.model_id !== data.model_id);
    }
    // console.log("modelArray: ", modelArray)
    this.setState({showModelEdit: !this.state.isModelSelectedChecked ? data : {}, isModelSelectedChecked: !this.state.isModelSelectedChecked, modelToDelete: modelArray});
  };

  handleModalVersionModel = (dataModel) => {
    this.setState({showVersion: !this.state.showVersion, showModelAddVersion: dataModel});
  };

  selectVersionDelete = (dataModel, dataVersion) => {
    const { versionToDelete } = this.state;
    // console.log("versionToDelete: ", versionToDelete)
    let versionArray = [];
    let filterVersion = versionToDelete.filter(val => val.version_name === dataVersion.version_name && val.version_date === dataVersion.version_date);
    // console.log("filterVersion: ", filterVersion)
    if(filterVersion.length === 0) {
      versionArray = [...versionToDelete, dataVersion]
    } else {
      versionArray = versionToDelete.filter(val => val.version_name !== dataVersion.version_name && val.version_date !== dataVersion.version_date);
    }
    // console.log("versionArray: ", versionArray)
    this.setState({showModelDeleteVersion: dataModel, versionToDelete: versionArray});
  };

  toggleModalDelete = () => {
    const { fetchDeleteModel } = this.props;
    const { userView, modelToDelete } = this.state;
    const idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    let userModelsObj = {
      token: idToken,
      client_id: userView._id,
      model_id: modelToDelete[0].model_id,
    };
    fetchDeleteModel(userModelsObj);
  }

  toggleModalVersionDelete = () => {
    const { fetchVersionOperation } = this.props;
    const { userView, showModelDeleteVersion, versionToDelete } = this.state;
    const idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    let userVersionsObj = {
      token: idToken,
      client_id: userView._id,
      model_id: showModelDeleteVersion.model_id,
      operation: "pop",
      pop_version_name: versionToDelete.version_name,
      new_version: null
    }
    console.log(userVersionsObj)
    fetchVersionOperation(userVersionsObj)
    this.setState({
      versionToDelete: {},
      showModelDeleteVersion: {}
    })
  };

  warningWithConfirmMessage = (email) => {
    console.log(email)
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.removeUser(email)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
          btnSize=""
        >
          You will not be able to recover this user!
        </ReactBSAlert>
      )
    });
  };

  warningWithConfirmMessageDeleteModel = () => {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.toggleModalDelete()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
          btnSize=""
        >
          You will not be able to recover this model!
        </ReactBSAlert>
      )
    });
  };

  warningWithConfirmMessageDeleteVersion = (dataModel, dataVersion) => {
    console.log(dataModel, dataVersion)
    this.setState({
      showModelDeleteVersion: dataModel,
      versionToDelete: dataVersion,
      alert: (
        <ReactBSAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.toggleModalVersionDelete()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
          btnSize=""
        >
          You will not be able to recover this version!
        </ReactBSAlert>
      )
    });
  };

  successDelete = () => {
    this.setState({
      alert: (
        <ReactBSAlert
          success
          style={{ display: "block", marginTop: "-100px" }}
          title="Deleted!"
          onConfirm={() => this.userRemovedStateInitialize()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="success"
          btnSize=""
        >
          User has been deleted.
        </ReactBSAlert>
      )
    });
  };

  successDeleteModel = () => {
    this.setState({
      alert: (
        <ReactBSAlert
          success
          style={{ display: "block", marginTop: "-100px" }}
          title="Deleted!"
          onConfirm={() => this.userRemovedStateInitialize()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="success"
          btnSize=""
        >
          Model has been deleted.
        </ReactBSAlert>
      ),
      isModelSelectedChecked: false,
      showModelEdit: {}
    });
  };

  successDeleteVersion = () => {
    this.setState({
      alert: (
        <ReactBSAlert
          success
          style={{ display: "block", marginTop: "-100px" }}
          title="Deleted!"
          onConfirm={() => this.versionDeletedStateInitialize()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="success"
          btnSize=""
        >
          Version has been deleted.
        </ReactBSAlert>
      ),
      isModelSelectedChecked: false,
      showModelEdit: {}
    });
  };

  hideAlert = () => {
    this.setState({
      alert: null
    });
  };

  userRemovedStateInitialize = () => {
    // console.log("user initialize")
    const { fetchRemoveUserInitialize } = this.props;
    fetchRemoveUserInitialize();
    this.setState({
      alert: null
    });
  }

  modelDeletedStateInitialize = () => {
    // console.log("model initialize")
    const { fetchDeleteModelInitialize } =  this.props;
    fetchDeleteModelInitialize();
    this.setState({
      alert: null
    });
  };

  versionDeletedStateInitialize = () => {
    // console.log("version initialize")
    const { fetchDeleteVersionInitialize } =  this.props;
    fetchDeleteVersionInitialize();
    this.setState({
      alert: null
    });
  };

  render() {
    let {
      userList,
      modelToDelete,
    } = this.state;

    let data = userList.length !== 0 ? userList : []
    
    return (
        <>
        <div className="rna-container">
          <NotificationAlert ref="notificationAlert" />
        </div>
        <div className="content">
          {this.state.alert}
          <Row className="mt-5">
            <Col className="ml-auto mr-auto" xs={11} md={11}>
              <Card>
                <CardBody>
                  <div style={{display: "flex", justifyContent: "flex-end", alignItems: "flex-end"}}>
                    <Button className="like " color='info' onClick={this.handleAddUserModal}>
                      Add User
                    </Button>
                  </div>
                  <ReactTable
                    data={data}
                    filterable
                    resizable={false}
                    columns={[
                      {
                        Header: "#",
                        accessor: "id",
                        filterable: false,
                        Cell: (row) => { return <div>{row.viewIndex + 1}</div> },
                        minWidth: 50
                      },
                      {
                        Header: "Email",
                        accessor: "email",
                        minWidth: 200
                      },
                      {
                        Header: "Organization",
                        accessor: "organization"
                      },
                      {
                        Header: "Admin",
                        accessor: "is_admin"
                      },
                      {
                        Header: "Actions",
                        accessor: "actions",
                        sortable: false,
                        filterable: false,
                        Cell: row => {
                          let userData = row.original;
                          return (
                            // we've added some custom button actions
                            <div className="actions-right">
                              <Button
                                onClick={this.toggleModalWatchUserData.bind(this)}
                                color="info"
                                size="sm"
                                className={classNames("btn-icon btn-link like btn-neutral")}
                                id={userData._id}
                              >
                                <i className="tim-icons icon-zoom-split" />
                              </Button>{" "}
                              {/* use this button to add a edit kind of action */}
                              <Button
                                onClick={this.toggleModalEditUserData.bind(this)}
                                color="warning"
                                size="sm"
                                className={classNames("btn-icon btn-link like btn-neutral")}
                                id={userData._id}
                              >
                                <i className="tim-icons icon-pencil" />
                              </Button>{" "}
                              {/* use this button to remove the data row */}
                              <Button
                                onClick={this.warningWithConfirmMessage.bind(this, row.original._id)}
                                color="warning"
                                size="sm"
                                className={classNames("btn-icon btn-link like btn-neutral")}
                                id={userData._id}
                              >
                                <i className="tim-icons icon-trash-simple" />
                              </Button>{" "}
                            </div>
                          )
                        }
                      }
                    ]}
                    defaultPageSize={5}
                    showPaginationTop={false}
                    showPaginationBottom
                    PreviousComponent={props => (
                      <Button {...props} className="btn-icon btn-link like btn-neutral" color='info'>
                        <i className="tim-icons icon-minimal-left" style={{fontSize: "20px", fontWeight: "bold"}}/>
                      </Button>
                    )}
                    NextComponent={props => (
                      <Button {...props} className="btn-icon btn-link like btn-neutral" color='info'>
                        <i className="tim-icons icon-minimal-right" style={{fontSize: "20px", fontWeight: "bold"}}/>
                      </Button>
                    )}
                    className="-striped -highlight"
                  />
                </CardBody>
              </Card>
              {/*register user*/}
              <UserRegisterModal 
                addUser={this.state.addUser} 
                handleAddUserModal={this.handleAddUserModal}
              />
              {/*watch data*/}
              <WatchUserModal 
                modalWatchUserData={this.state.modalWatchUserData} 
                toggleModalWatchUserData={this.toggleModalWatchUserData}
              />
              {/*model operations*/}
              <UserEditModal 
                modalEditUserData={this.state.modalEditUserData} 
                toggleModalEditUserData={this.toggleModalEditUserData.bind(this)} 
                warningWithConfirmMessageDeleteModel={this.warningWithConfirmMessageDeleteModel.bind(this)}
                handleEditModelModal={this.handleEditModelModal.bind(this)}
                handleAddModelModal={this.handleAddModelModal.bind(this)}
                toggleModalEditModel={this.toggleModalEditModel.bind(this)}
                handleModalVersionModel={this.handleModalVersionModel.bind(this)}
                warningWithConfirmMessageDeleteVersion={this.warningWithConfirmMessageDeleteVersion.bind(this)}
                modelToDelete={modelToDelete}
                userView={this.state.userView}
              />
              {/*register model*/}
              <ModelRegisterModal
                addModel={this.state.addModel}
                handleAddModelModal={this.handleAddModelModal}
                userView={this.state.userView}
              />
              {/*edit model*/}
              <ModelEditModal
                editModel={this.state.editModel}
                handleEditModelModal={this.handleEditModelModal}
                userView={this.state.userView}
                modelToDelete={modelToDelete}
                showModelEdit={this.state.showModelEdit}
              />
              {/*add version*/}
              <VersionRegisterModal
                showVersion={this.state.showVersion}
                handleModalVersionModel={this.handleModalVersionModel}
                userView={this.state.userView}
                showModelAddVersion={this.state.showModelAddVersion}
              />
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

function mapStateToProps({user, auth}){
  return{
      user,
      auth
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators(
      { 
        fetchGetUserList, 
        fetchRemoveUser, 
        fetchGetModelsByUserId, 
        fetchDeleteModel, 
        fetchVersionOperation, 
        fetchRemoveUserInitialize, 
        fetchDeleteModelInitialize ,
        fetchDeleteVersionInitialize
      }, dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Users);